import stateClasses from "../data/stateClasses";

export default class Mp4Video {
	
	constructor() {
		this.$playerEl = $();
		this.$containerEl = $();
		this.$playButton = $();
		this.autoPlay = false;
	}

	isPlaying() {
		const el = this.$playerEl.get(0);
		return !!(el.currentTime > 0 && !el.paused && !el.ended && el.readyState > 2);
	}

	init(el) {

		this.$playerEl = $(el);
		this.$containerEl = $(el).closest('.js-video-container');
        this.$playButton = this.$containerEl.find('.js-play-button');
        this.autoPlay = el.getAttribute('autoplay') !== null;

		if (this.isPlaying()) {
			this.$containerEl.addClass(stateClasses.isPlaying);
		} else {
			el.addEventListener('playing', () => this.$containerEl.addClass(stateClasses.isPlaying));
		}

		if (!this.autoPlay) {
			this.$playButton.on('click', () => el.play());
			el.addEventListener('ended', () => this.$containerEl.removeClass(stateClasses.isPlaying));
		}
	}
}